import React from "react";
import { useParams, Link } from "react-router-dom";

import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import { TrainingData } from "../Data/CommunityCoursesData";

import "./Training.css";

const categoryImageMap = {
  'default': require('./training_hero_bg.png'),
};

const getCategoryImage = (categoryId) => {
  return categoryImageMap[categoryId] || categoryImageMap.default;
};

const TrainingPage = () => {
  const { id, categoryId } = useParams();
  const courseId = categoryId || id;
  const course = TrainingData.find((c) => c.id === courseId);

  if (!course) {
    return (
      <div className="programme-v2">
        <Navbar />
        <div className="not-found-v2">
          <div className="not-found-v2__icon">404</div>
          <h2>Training category not found</h2>
          <p>The training category you're looking for doesn't exist.</p>
          <Link to="/training" className="not-found-v2__link">
            ← Back to Training
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  const image = getCategoryImage(course.id);
  const imageUrl = typeof image === 'object' && image.default ? image.default : image;

  return (
    <div className="programme-v2">
      <Navbar />
      
      <section 
        className="hero-v2 hero-v2--with-image" 
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.5)), url(${imageUrl})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "#ffffff"
        }}
      >
        <div className="hero-v2__container">
          <Link to="/training" className="hero-v2__back">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M15 10H5M5 10L10 5M5 10L10 15" />
            </svg>
            All Training
          </Link>

          <div className="hero-v2__badges">
            <span className="hero-v2__badge hero-v2__badge--category">{course.category || 'Training'}</span>
          </div>

          <h1 className="hero-v2__title">{course.title}</h1>
          {course.shortDescription && (
            <p className="hero-v2__tagline">{course.shortDescription}</p>
          )}
        </div>
      </section>

      <div className="programme-v2__main">
        <div className="programme-v2__content" style={{maxWidth: '100%'}}>
          
          {course.description && (
            <section className="section-v2">
              <h2 className="section-v2__title">Overview</h2>
              <p className="section-v2__text">{course.description}</p>
            </section>
          )}
          
          {course.whoThisHelps && course.whoThisHelps.length > 0 && (
            <section className="section-v2">
              <h2 className="section-v2__title">Who This Helps</h2>
              <div className="for-v2">
                {course.whoThisHelps.map((item, i) => (
                  <div key={i} className="for-v2__item">
                    <div className="for-v2__check">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M13.5 4.5L6 12l-3.5-3.5" />
                      </svg>
                    </div>
                    <span>{item}</span>
                  </div>
                ))}
              </div>
            </section>
          )}
          
          {course.programs && course.programs.length > 0 && (
            <section className="section-v2">
              <h2 className="section-v2__title">Available Programmes</h2>
              <p className="section-v2__subtitle">{course.programs.length} courses available</p>
              <div className="tp-programmes-grid">
                {course.programs.map((program, index) => (
                  <Link 
                    key={index} 
                    to={`/training/personal/${course.id}/${program.id}`}
                    className="tp-programme-card"
                  >
                    <div className="tp-programme-card__header">
                      <h3 className="tp-programme-card__name">{program.name}</h3>
                      {program.level && (
                        <span className="tp-programme-card__level">{program.level}</span>
                      )}
                    </div>
                    <p className="tp-programme-card__desc">{program.shortDescription}</p>
                    <div className="tp-programme-card__footer">
                      <span className="tp-programme-card__duration">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <circle cx="12" cy="12" r="10" />
                          <path d="M12 6v6l4 2" />
                        </svg>
                        {program.duration}
                      </span>
                      <span className="tp-programme-card__link">
                        View details
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M5 12h14M12 5l7 7-7 7" />
                        </svg>
                      </span>
                    </div>
                  </Link>
                ))}
              </div>
            </section>
          )}
          
          {course.features && course.features.length > 0 && (
            <section className="section-v2">
              <h2 className="section-v2__title">Package Features</h2>
              <ul className="requirements-v2">
                {course.features.map((feature, i) => (
                  <li key={i} className="requirements-v2__item">
                    <span className="requirements-v2__bullet">✓</span>
                    {feature}
                  </li>
                ))}
              </ul>
            </section>
          )}
          
          {course.outcomes && course.outcomes.length > 0 && (
            <section className="section-v2">
              <h2 className="section-v2__title">Outcomes</h2>
              <div className="for-v2">
                {course.outcomes.map((outcome, i) => (
                  <div key={i} className="for-v2__item">
                    <div className="for-v2__check">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M13.5 4.5L6 12l-3.5-3.5" />
                      </svg>
                    </div>
                    <span>{outcome}</span>
                  </div>
                ))}
              </div>
            </section>
          )}
          
          {course.successStory && (
            <section className="section-v2">
              <div className="story-v2">
                <div className="story-v2__quote">
                  <svg width="48" height="48" viewBox="0 0 48 48" fill="currentColor">
                    <path d="M12 24c0-6.627 5.373-12 12-12v-8c-11.046 0-20 8.954-20 20h8zm24 0c0-6.627-5.373-12-12-12v-8c11.046 0 20 8.954 20 20h-8z" />
                  </svg>
                  <p>{course.successStory.quote}</p>
                </div>
                <div className="story-v2__author">
                  <div className="story-v2__avatar">
                    {course.successStory.name.charAt(0)}
                  </div>
                  <div className="story-v2__info">
                    <span className="story-v2__name">{course.successStory.name}</span>
                    <span className="story-v2__bg">{course.successStory.background}</span>
                  </div>
                </div>
                <p className="story-v2__journey">{course.successStory.journey}</p>
              </div>
            </section>
          )}
          
          {course.enrollmentInfo && (
            <section className="section-v2">
              <h2 className="section-v2__title">Enrolment Information</h2>
              <div className="assessment-v2">
                {course.enrollmentInfo.cost && (
                  <div className="assessment-v2__item">
                    <strong>Cost:</strong> {course.enrollmentInfo.cost}
                  </div>
                )}
                {course.enrollmentInfo.schedule && (
                  <div className="assessment-v2__item">
                    <strong>Schedule:</strong> {course.enrollmentInfo.schedule}
                  </div>
                )}
                {course.enrollmentInfo.nextIntake && (
                  <div className="assessment-v2__item">
                    <strong>Next Intake:</strong> {course.enrollmentInfo.nextIntake}
                  </div>
                )}
                {course.enrollmentInfo.childcare && (
                  <div className="assessment-v2__item">
                    <strong>Childcare:</strong> {course.enrollmentInfo.childcare}
                  </div>
                )}
              </div>
            </section>
          )}
          
          <section className="section-v2">
            <div className="sidebar-v2 sidebar-v2--cta" style={{maxWidth: '400px'}}>
              <h3 className="sidebar-v2__title">Ready to start?</h3>
              <p className="sidebar-v2__text">Get in touch to discuss enrolment and funding options.</p>
              <Link to="/contact" className="sidebar-v2__button">
                Enquire now
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 10h12M12 4l6 6-6 6" />
                </svg>
              </Link>
            </div>
          </section>
          
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default TrainingPage;
